/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */

import React from 'react'
import PropTypes from 'prop-types'
import {
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalOverlay
} from '@salesforce/retail-react-app/app/components/shared/ui'
import ProductView from '../product-view'
import {useProductViewModal} from '../../hooks/use-product-view-modal'
import {CloseIcon} from '../custom-icons'

/**
 * A Modal that contains Product View
 */
const ProductViewModal = ({product, isOpen, onClose, shouldHideBreadcrumb = true, ...props}) => {
    const productViewModalData = useProductViewModal(product)

    return (
        <Modal size="large" isOpen={isOpen} onClose={onClose}>
            <ModalOverlay />
            <ModalContent
                containerProps={{'data-testid': 'product-view-modal'}}
                p={['64px 10px 67px', null, null, 24]}
                mt={[120, null, null, 'auto']}
                mb="auto"
            >
                <ModalCloseButton>
                    <CloseIcon boxSize="14px" />
                </ModalCloseButton>
                <ModalBody>
                    <ProductView
                        showFullLink={true}
                        imageSize="sm"
                        product={productViewModalData.product}
                        isLoading={productViewModalData.isFetching}
                        onProductIdChange={productViewModalData.onProductIdChange}
                        isModal={true}
                        shouldHideBreadcrumb={shouldHideBreadcrumb}
                        {...props}
                    />
                </ModalBody>
            </ModalContent>
        </Modal>
    )
}

ProductViewModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onOpen: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
    product: PropTypes.object,
    isLoading: PropTypes.bool,
    shouldHideBreadcrumb: PropTypes.bool
}

export default ProductViewModal
